export class IkeObject {
	/**
	 * Copy Keys from src into dest omitting any null or undefined values
	 *
	 * @param dest the destination object to copy into
	 * @param src the source object to copy from
	 * @returns nothing as the destination object is updated.
	 */
	static assignNotNull<D, S extends object>(dest: D, src: S): void {
		for (const key of Object.keys(src)) {
			const value = (src as { [key: string]: unknown })[key];
			if (value == null) {
				continue;
			}
			(dest as { [key: string]: unknown })[key] = value;
		}
	}

	/**
	 * Recursively extracts all values from an object and its nested objects.
	 *
	 * @param obj - The object to extract values from
	 * @param result - Optional Set to accumulate values (used internally for recursion)
	 * @returns An array of values found at all levels of the object
	 *
	 * @example
	 * flattenObjectValuesUnique({ a: 1, b: { c: 2, d: { e: 3 } } })
	 * // Returns: [1, 2, 3]
	 */
	static flattenObjectValuesUnique(obj: unknown, result = new Set<unknown>()): unknown[] {
		if (typeof obj !== 'object' || obj === null) {
			return Array.from(result);
		}

		for (const value of Object.values(obj)) {
			if (typeof value === 'object' && value !== null) {
				this.flattenObjectValuesUnique(value, result);
			} else {
				result.add(value);
			}
		}

		return Array.from(result);
	}
}
